import { render, staticRenderFns } from "./iam-list-page.vue?vue&type=template&id=30ebe906&"
import script from "./iam-list-page.vue?vue&type=script&lang=js&"
export * from "./iam-list-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports